var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.editor ? _c("div", { attrs: { id: _vm.holder } }) : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }